﻿<div class="lb-modal">
    <div class="lb-modal-body" *ngIf="display">
        <ng-content></ng-content>
    </div>
</div>
<div class="lb-modal-background"></div>
